import * as types from '../types'

export default (payload) => {
  return {
    type: types.SET_SENSOR_EVENTS_LOADING_START,
    payload,
  }
}
